/**
 *
 * @param contentString
 * @param baseOptions
 * @param baseValues
 * @deprecated
 * @constructor
 */
export class Engine {
	constructor( library, contentString, baseOptions, baseValues ) {
		this.library = library;
		this.contentString = contentString;
		this.baseOptions = baseOptions;
		this.baseValues = baseValues;
		this._templateTree = this._createTemplateTree( this.contentString );
	}

	_blockTypes = {
		"~": function( tree, blockData, data ) {
			if( !Array.isArray(blockData) ) {
				return "";
			}
	
			var totalContent = "";
	
			for( var i = 0, len = blockData.length; i < len; i += 1 ) {
				totalContent += this.constructStringFromObject( tree, blockData[ i ], data, i );
			}
	
			return totalContent;
		},
	
		"!": function( tree, blockData, data ) {
			if( blockData ) {
				return this.constructStringFromObject( tree, blockData, data );
			}
	
			return "";
		},
	
		"+": function( tree, blockData, data ) {
			var totalContent = "";
	
			for( var i = 0; i < blockData; i += 1 ) {
				totalContent += this.constructStringFromObject( tree, blockData, data, i );
			}
	
			return totalContent;
		}
	};
	
	/**
	 * Was in the old ext lib, we don't need, but don't want to break anything
	 * @deprecated
	 */
	compile() {
	};
	
	/**
	 *
	 * @param {Element|string|jQuery} ele
	 * @param {object} data
	 * @param {Function=} callback
	 */
	append( ele, data, callback ) {
		var dataAndCallback = this.getDataAndCallback( data, callback );
	
		data = dataAndCallback.data;
		callback = dataAndCallback.callback;
	
		var totalContent = this.populate( data );
	
		this.finishProcess( ele, totalContent, callback, false );
	};
	
	/**
	 *
	 * @param {Element|string|jQuery} ele
	 * @param {object} data
	 * @param {Function=} callback
	 */
	prepend( ele, data, callback ) {
		var dataAndCallback = this.getDataAndCallback( data, callback );
	
		data = dataAndCallback.data;
		callback = dataAndCallback.callback;
	
		var totalContent = this.populate( data );
	
		this.finishProcess( ele, totalContent, callback, true );
	};
	
	/**
	 *
	 * @param {Element|string|jQuery} ele
	 * @param {object} data
	 * @param {Function=} callback
	 */
	overwrite( ele, data, callback ) {
		this.emptyHTML( ele );
		this.append( ele, data, callback );
	};
	
	/**
	 *
	 * @param {Element|string|jQuery} ele
	 */
	emptyHTML( ele ) {
		this.library.empty( ele );
	};
	
	/**
	 *
	 * @param data
	 * @return {*}
	 */
	populate( data ) {
		var totalContent = "";
	
		data = data || {};
	
		if( Array.isArray( data ) ) {
			for( var i = 0, len = data.length; i < len; i++ ) {
				var itemDataWithBase = this.library.extend( {}, this.baseValues, data[i] );
				totalContent += this.constructStringFromObject( this._templateTree, itemDataWithBase, itemDataWithBase, i );
			}
	
			return totalContent;
		} else {
			var dataWithBase = this.library.extend( {}, this.baseValues, data );
			totalContent = this.constructStringFromObject( this._templateTree, dataWithBase, dataWithBase );
		}
	
		return totalContent;
	};
	
	/**
	 *
	 * @param {String|jQuery} ele
	 * @param content
	 * @param callback
	 * @param shouldPrepend
	 */
	finishProcess( ele, content, callback, shouldPrepend ) {
		this.addHTML( ele, content, shouldPrepend );
	
		if( typeof callback === "function" ) {
			callback();
		}
	};
	
	/**
	 *
	 * @param {Element|string|jQuery} ele
	 * @param {String} content
	 * @param {Boolean} shouldPrepend
	 */
	addHTML( ele, content, shouldPrepend ) {
		if( shouldPrepend ) {
			this.library.prepend( ele, content );
		} else {
			this.library.append( ele, content );
		}
	};
	
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
	
	/**
	 *
	 * @param {Object|String} tree
	 * @param {Object} blockData the main block data
	 * @param {Object=} data the global parent data
	 * @param {Number} loopIndex if we're in a loop, this will be set
	 * @return {String}
	 */
	constructStringFromObject( tree, blockData, data, loopIndex ) {
		// if we were only called with no global data but with local data, we assume that's our global data.
		if( !data && arguments.length == 2 ) {
			data = blockData;
		}
	
		// if this is a string already, then there's nothing to do.
		if( typeof tree === "string" ) {
			return this.processTemplateVariables( tree, blockData, data, loopIndex );
		}
	
		// taking the before and after pieces, call this function over again so we know we actually have a string.
		var templateLevel = [tree.before, tree.after];
	
		for( var i = 0, len = templateLevel.length; i < len; i += 1 ) {
			var nextTree = templateLevel[ i ];
	
			templateLevel[ i ] = this.constructStringFromObject( nextTree, blockData, data, loopIndex );
		}
	
		var innerParsed = "";
	
		if( tree.variable in blockData || tree.variable == this.baseOptions.currentVariableName ) {
			var localBlockData = ( tree.variable == this.baseOptions.currentVariableName
				)
				? blockData
				: blockData[ tree.variable ];
	
			// if the piece of the template block we're dealing with is a string
			// then this means we can just execute it with this blocks details.
			innerParsed = this.executeTemplateBlock( tree.blockType, tree.inner, localBlockData, data )
		} else {
			// we don't actually want to do anything here, if the variable isn't there, then the block is hidde and thus,
			// nothing should show.
			// throw "variable '" + tree.variable + "' was not found in block type '" + tree.blockType + "'";
		}
	
		return templateLevel[0] + innerParsed + templateLevel[ 1 ];
	};
	
	executeTemplateBlock( blockType, tmpl, blockData, data ) {
		var blockResult = "";
	
		if( this._blockTypes[ blockType ] ) {
			blockResult = this._blockTypes[ blockType ].apply( this, [tmpl, blockData, data] );
		} else {
			throw "Block type '" + blockType + "' is not defined!";
		}
	
		return blockResult
	};
	
	/**
	 *
	 * @param {String} content
	 * @return {String|Object}
	 * @private
	 */
	_createTemplateTree( content ) {
		var templateObject = null;
	
		/**
		 * Parse a "#" and then a single character symbol, the rest is the variable name. and then another #
		 * Example: #~variableName#, #/~# but not ##test##, we are excluding @, {, and # as invalid character
		 * tokens.
		 */
		var tokenRegExString = "#([^\\w\\s\\d@\\{#]){1}[\\w\\d\\.]*#";
		var startBlockRegex = new RegExp( tokenRegExString, "g" );
		var startBlockResults = content.match( startBlockRegex );
	
		// if we don't have any results, there are no blocks here
		// and thus we can return whatever the contents are
		if( !startBlockResults ) {
			return content;
		}
	
		var blockString = startBlockResults[ 0 ];
	
		// each token consists of a block type and bound variable, pull that apart.
		var variableAndTypeOfBlock = this.getBlockDetails( blockString );
		var blockType = variableAndTypeOfBlock.blockType;
		var boundVariable = variableAndTypeOfBlock.variableName;
	
		// we now are going to parse every block type from the first available match
		var tokenRegexString = "[#]{1}" + // only 1 #
			"(?:" + this.escapeRegExp( blockType ) + "|\\\/){1}" + // only the block type or closing block /
			"[\\.\\w\\d\\" + this.escapeRegExp( blockType ) + "]*" + // only the block type or the variable name
			"[#]{1}"; // the last #
	
		// we're gonna an easy method of parsing, we're gonna use the above regex to parse the first starting token
		// and then count our way through till we find the appropriate closing one.
		var openingCount = 0;
	
		var firstToken = null;
		var lastToken = null;
	
		while( firstToken == null || ( nextToken != null && openingCount != 0
			) ) {
			var nextToken = null;
	
			if( lastToken != null ) {
				nextToken = this.matchRegExWithOffset( tokenRegexString, content, lastToken.index + lastToken[ 0 ].length );
			} else {
				nextToken = this.matchRegExWithOffset( tokenRegexString, content, 0 );
				firstToken = nextToken;
			}
	
			if( nextToken ) {
				if( nextToken[ 0 ].indexOf( "/" ) == 1 ) {
					openingCount--;
				} else {
					openingCount++;
				}
	
				lastToken = nextToken;
			} else if( nextToken ) {
				lastToken = nextToken;
			}
		}
	
		// if opening count is zero then this means that the template was parsed properly,
		// we can break it up and be recursive now
		if( openingCount === 0 ) {
	
			// the actual text between the tokens, we don't want the actual tokens.
			var inner = content.substring( firstToken.index + firstToken[ 0 ].length, lastToken.index );
			var before = content.substring( 0, firstToken.index ) || "";
			var after = content.substring( lastToken.index + lastToken[ 0 ].length ) || "";
	
	
			templateObject = {
				blockType: blockType,
				variable:  boundVariable,
				after:     this._createTemplateTree( after ),
				before:    this._createTemplateTree( before ),
				inner:     this._createTemplateTree( inner )
			};
		} else {
			throw "Template error?! Couldn't find closing tag somewhere."; // this shouldn't happen. i couldn't find the closing
		}
	
		return templateObject;
	};
	
	/**
	 *
	 * @param {String} str
	 */
	getBlockDetails( str ) {
		var regexString = "#([^#])([A-Za-z0-9\\.]+)#",
			regex = new RegExp( regexString, "g" ),
			result = regex.exec( str );
	
		if( result ) {
			return {
				blockType:    result[ 1 ],
				variableName: result[ 2 ]
			};
		}
	
		return null;
	};
	
	/**
	 *
	 * @param {String} tmpl
	 * @param {Object=} blockData
	 * @param {Object=} data
	 * @param {Number=} loopIndex
	 * @return {*}
	 */
	processTemplateVariables( tmpl, blockData, data, loopIndex ) {
		tmpl = this.processTokenReplacement( tmpl, blockData, "##", "##", loopIndex );
		tmpl = this.processTokenReplacement( tmpl, data || blockData, "{", "}", loopIndex );
	
		return tmpl;
	};
	
	/**
	 * Search a template string and replace the tokens variable name with a value.
	 *
	 * @param {String} str
	 * @param {Object} data
	 * @param {String} tokenPrefix
	 * @param {String} tokenSuffix
	 * @param {Number=} loopIndex
	 * @return {String} a parsed version of the template string
	 */
	processTokenReplacement( str, data, tokenPrefix, tokenSuffix, loopIndex ) {
		//	var regexString = tokenPrefix + "([\\w\\d]*)" + tokenSuffix;
		var regexString = tokenPrefix + "([\.@\\w\\d]*)" + tokenSuffix;
		var regex = new RegExp( regexString, "g" );
		var matches = str.match( regex );
		var checkedMatches = {};
	
		if( !matches ) {
			return str;
		}
	
		for( var i = 0, len = matches.length; i < len; i += 1 ) {
			var match = matches[ i ];
	
			if( !checkedMatches[ match ] ) {
				var varName = match.substring(
					tokenPrefix.length,
					match.length - tokenSuffix.length
				);
	
				var value = ( varName == this.baseOptions.loopIndexVariableName
					)
					? loopIndex
					: ( varName === this.baseOptions.currentVariableName
					)
					? data
					: this.getDataItemByKey( varName, data );
	
				// if the value is a function, then we call it with some of the template features so it can make decisions
				// at runtime
				if( typeof value === "function" ) {
					value = value.apply( this, [data, loopIndex] );
				}
	
				var replaceRegExString = this.escapeRegExp( tokenPrefix + varName + tokenSuffix ),
					replaceRegEx = new RegExp( replaceRegExString, "g" );
	
				if( value !== undefined && value != null ) {
					// returning the value as a function here had an adverse affect in IE9/10 where
					// replacing any strings contents with a value that contains "$0", it will replace
					// the "$0" with whatever the token of the original query
					str = str.replace( replaceRegEx, function() { return value; } );
				} else {
					str = str.replace( replaceRegEx, "" );
				}
	
				checkedMatches[ match ] = true;
			}
		}
	
		return str;
	};
	
	/**
	 *
	 * @param {String} regexString a regex string
	 * @param {String} content
	 * @param {Number} offset
	 * @return {Array.<String>}
	 */
	matchRegExWithOffset( regexString, content, offset ) {
		var trimmedContent = content.substring( offset );
		var regex = new RegExp( regexString, "g" );
		var result = regex.exec( trimmedContent );
	
		if( result ) {
			// set the offset regex values so it looks legit
			result.index += offset;
			result.input = content;
			result.offset = offset;
		}
	
		return result;
	};
	
	/**
	 *
	 * @param {Object|Null|Function} data
	 * @param {Function|Null} callback
	 * @return {Object}
	 */
	getDataAndCallback( data, callback ) {
		if(
			typeof data === "function" &&
				( callback === undefined || callback === null
					)
			) {
			callback = data;
			data = {};
		} else if( data === undefined || data === null ) {
			data = {};
		}
	
		return {
			data:     data,
			callback: callback
		};
	};
	
	// *********************************************************************************************************************
	// *********************************************************************************************************************
	
	/**
	 * Parses down a string in dot notation and essentially evals it and returns the value
	 *
	 * @param {String} key the variable in dot notation
	 * @param {Object} data the object the data should be parsed from
	 * @return {*} the value can be any type
	 */
	getDataItemByKey( key, data ) {
		var value = null,
			dots = key.split( "." );
	
		for( var i = 0, len = dots.length; i < len; i += 1 ) {
			value = ( value
				)
				? value[ dots[i] ]
				: data[ dots[i] ];
		}
	
		return value;
	};
	
	escapeRegExp( str ) {
		return str.replace( /[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&" );
	};
	

}

